import { InjectionToken } from '@angular/core';
export const INPUT_OPTIONS_DYNAMIC_HOST = /*#__PURE__*/new InjectionToken('input-options-dynamic-host');